import { Card, CardBody, Typography } from '@material-tailwind/react';
import React from 'react'

export default function LoadingPage() {
  return (
    <Card className="bg-white shadow-2xl shadow-blue-300">
      <CardBody>
        <Typography variant="h6" className="mb-2 font-nunito text-center bg-yellow-300 text-primary-900">
          Please wait while we get the information for you...
        </Typography>
      </CardBody>
    </Card>
  );
}